import * as yup from 'yup'

export const CONDITION_VALUES = ['very_good', 'good', 'bad', 'very_bad'] as const
export type ConditionType = (typeof CONDITION_VALUES)[number]

const oneOfTyped = <T extends readonly string[]>(values: T) =>
  yup.string().oneOf([...values]) as yup.StringSchema<T[number]>

export const schema = yup.object({
  idPasto: yup.string().nullable().optional(),
  idFazenda: yup.string().required('O id da fazenda é obrigatório'),
  descricao: yup
    .string()
    .required('O nome do local é obrigatório')
    .test('unique-name', 'Esse nome já existe', function (value) {
      if (!value) return true

      const { existingNames = [], currentName } = this.options.context || {}

      if (value === currentName) return true

      return !existingNames.includes(value)
    }),
  area: yup.number().nullable().optional().typeError('A área deve ser um número'),
  classificacao: yup.string().nullable().optional(),
  acao: yup.string().optional(),
  pasto: oneOfTyped(CONDITION_VALUES).required('A condição do pasto é obrigatória'),
  aguados: oneOfTyped(CONDITION_VALUES).required('A condição das aguadas é obrigatória'),
  saleiros: oneOfTyped(CONDITION_VALUES).required('A condição dos saleiros é obrigatória'),
  cerca: oneOfTyped(CONDITION_VALUES).required('A condição da cerca é obrigatória')
})

export type PastureForm = yup.InferType<typeof schema>
export default schema
